import React from 'react'
import usePortManager from '../hooks/use-port-manager'
import { observer } from 'mobx-react'

function getDoorStyle (portManager) {

  const portHeight = portManager.getPortHeight()
  const portWidth = portManager.getPortWidth()
  const position = portManager.getValue('door')

  const positionFromBottom = getDoorPositionFromBottom(portManager.getDoorSteps())
  const positionFromBottomPercent = (positionFromBottom / portHeight) * 100

  const doorHeight = 201 - positionFromBottom

  const doorWidthPercent = (101 / portWidth) * 100
  const doorHeightPercent = (doorHeight / portHeight) * 100

  const positionFromCenter = getDoorPositionFromCenter(position, portWidth, portManager)
  const positionFromCenterPercent = (positionFromCenter / portWidth) * 100

  const positionFromLeftPercent = 50 + positionFromCenterPercent

  return {
    bottom: positionFromBottomPercent + '%',
    left: positionFromLeftPercent + '%',
    width: doorWidthPercent + '%',
    height: doorHeightPercent + '%'
  }
}

function getDoorPositionFromCenter (position, portWidth, portManager) {
  let type, rows, columns

  if (portManager.getWindowProperties() !== null) {
    [type, rows, columns] = portManager.getWindowProperties(true)
  } else {
    if (portWidth >= 200.0 && portWidth < 400.0) {
      columns = 1
    } else if (portWidth >= 400.0 && portWidth < 500.0) {
      columns = 4
    } else if (portWidth >= 500.0 && portWidth < 600.0) {
      columns = 5
    } else if (portWidth === 600.0) {
      columns = 6
    }
  }

  if (position === 'center' && !portManager.when('doorAllowedCenter')) {
    position = 'left'
  } else if ((position === 'left' || position === 'right') && !portManager.when('doorAllowedSide')) {
    position = 'center'
  }

  switch (position) {
    case 'left':
      if (columns === 4) {
        return -100.5
      }
      if (columns === 5) {
        return -150.5
      }
      if (columns === 6) {
        return -200.5
      }
      break
    case 'right':
      if (columns === 4) {
        return -0.5
      }
      if (columns === 5) {
        return 49.5
      }
      if (columns === 6) {
        return 99.5
      }
      break
  }

  return -50.5
}

function getDoorPositionFromBottom (doorSteps) {
  if (doorSteps === 'standard') {
    return 18
  }

  return 2.5
}

function DoorLayer ({src = null, name = null, className = null}) {
  const port_manager = usePortManager()

  if (src === null && typeof port_manager.getValue(name) === 'undefined' || port_manager.getValue(name) === 'none' || port_manager.getPortModel() == 8000 || port_manager.getPortHeight() < 212.6) {
    return null
  }

  const base_url = window.main_theme_objects.assets_url
  const fullSrc = base_url + 'port-images/door/' + port_manager.getDoorDirection() + '_' + port_manager.getDoorSteps() + '.png'

  return (
    <img
      src={fullSrc}
      data-name={name}
      className={className}
      style={getDoorStyle(port_manager)}
    />
  )
}

export default observer(DoorLayer)